import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { useTableSearch } from "core/Operations/useTableSearch";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useVehicleInformationQuery } from "AppQuries/master/VehicleInformation/vehicleinformation";
import { format } from "date-fns";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const VehicleInformation = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useVehicleInformationQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [show, setShow] = useState(false);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <Can
            accessModule={accessCodes.others}
            accessCode={accessCodes.others_vehicle}
            accessType="haveEdit"
          >
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
            >
              <Link
                className="me-2 p-2"
                to={`${all_routes.vechile_master}/${all_routes.editvehicleinformation}/${record.vehicleNumber}`}
              >
                <Edit className="feather-edit" />
              </Link>
            </OverlayTrigger>
          </Can>
        </div>
      ),
    },
    {
      title: "S.No",
      dataIndex: "id",
      sorter: (a, b) => a.id.localeCompare(b.id),
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      sorter: (a, b) => a.vehicleNumber.localeCompare(b.vehicleNumber),
    },
    {
      title: "Vehicle Name",
      dataIndex: "vehicleName",
      sorter: (a, b) => a.vehicleName.localeCompare(b.vehicleName),
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      sorter: (a, b) => a.vehicleType.localeCompare(b.vehicleType),
    },
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => a.company.localeCompare(b.company),
    },
    {
      title: "Department",
      dataIndex: "department",
      sorter: (a, b) => a.department.localeCompare(b.department),
    },
    {
      title: "IU Label Number",
      dataIndex: "iuLabelNumber",
      sorter: (a, b) => a.iuLabelNumber.localeCompare(b.iuLabelNumber),
    },
    {
      title: "Chassis Number",
      dataIndex: "chassisNumber",
      sorter: (a, b) => a.chassisNumber.localeCompare(b.chassisNumber),
    },
    {
      title: "Vehicle Model",
      dataIndex: "vehicleModel",
      sorter: (a, b) => a.vehicleModel.localeCompare(b.vehicleModel),
    },
    {
      title: "Vehicle Category",
      dataIndex: "vehicleCategory",
      sorter: (a, b) => a.vehicleCategory.localeCompare(b.vehicleCategory),
    },
    {
      title: "Propellant",
      dataIndex: "propellant",
      sorter: (a, b) => a.propellant.localeCompare(b.propellant),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   render: (text) => (
    //     <div
    //       className={`badges badge-line${
    //         text === "Active" ? "success" : "danger"
    //       }`}
    //     >
    //       {text}
    //     </div>
    //   ),
    //   sorter: (a, b) => a.status.localeCompare(b.status),
    // },
    {
      title: "Asset Tag No",
      dataIndex: "assetTagNo",
      sorter: (a, b) => a.assetTagNo.localeCompare(b.assetTagNo),
    },
    {
      title: "GPS SIM No",
      dataIndex: "gpsSimNo",
      sorter: (a, b) => a.gpsSimNo.localeCompare(b.gpsSimNo),
    },
    {
      title: "Require Till",
      dataIndex: "requireTill",
      sorter: (a, b) => new Date(a.requireTill) - new Date(b.requireTill),
      render: (date) => format(new Date(date), "dd-MM-yyyy"),
    },
    {
      title: "Register Date",
      dataIndex: "registerDate",
      sorter: (a, b) => new Date(a.registerDate) - new Date(b.registerDate),
      render: (date) => format(new Date(date), "dd-MM-yyyy"),
    },
    {
      title: "Fine",
      dataIndex: "fine",
      sorter: (a, b) => a.fine - b.fine,
      render: (val) => (val ?? 0).toFixed(2),
    },
    {
      title: "Vehicle Belongs To",
      dataIndex: "vehicleBelongsTo",
      sorter: (a, b) => a.vehicleBelongsTo.localeCompare(b.vehicleBelongsTo),
    },
    {
      title: "Category",
      dataIndex: "category",
      sorter: (a, b) => a.category.localeCompare(b.category),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "Cost",
      dataIndex: "cost",
      sorter: (a, b) => a.cost - b.cost,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Purchase Cost",
      dataIndex: "purchaseCost",
      sorter: (a, b) => a.purchaseCost - b.purchaseCost,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Purchase From",
      dataIndex: "purchaseFrom",
    },
    {
      title: "Purchase Date",
      dataIndex: "purchaseDate",
      sorter: (a, b) => new Date(a.purchaseDate) - new Date(b.purchaseDate),
      render: (date) => format(new Date(date), "dd-MM-yyyy"),
    },
    {
      title: "COE Cost",
      dataIndex: "coeCost",
      sorter: (a, b) => a.coeCost - b.coeCost,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "COE Expiry Date",
      dataIndex: "coeExpiryDate",
      sorter: (a, b) => new Date(a.coeExpiryDate) - new Date(b.coeExpiryDate),
      render: (date) => format(new Date(date), "dd-MM-yyyy"),
    },
    {
      title: "Driver Name",
      dataIndex: "driverName",
    },
    {
      title: "Driver Contact No",
      dataIndex: "driverContactNo",
    },
    {
      title: "Nationality & WPS Pass",
      dataIndex: "statusNationalityAndWPSPass",
    },
    {
      title: "Job Site",
      dataIndex: "jobSite",
    },
    {
      title: "Job Number",
      dataIndex: "jobNumber",
    },
    {
      title: "Diesel Amount",
      dataIndex: "dieselAmount",
      sorter: (a, b) => a.dieselAmount - b.dieselAmount,
      render: (val) => `${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Diesel Top-up Amount",
      dataIndex: "dieselTopupAmount",
      sorter: (a, b) => a.dieselTopupAmount - b.dieselTopupAmount,
      render: (val) => `${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Rental Driver Cost",
      dataIndex: "rentalDriverCost",
      sorter: (a, b) => a.rentalDriverCost - b.rentalDriverCost,
      render: (val) => `${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Rental Vehicle Cost",
      dataIndex: "rentalVehicleCost",
      sorter: (a, b) => a.rentalVehicleCost - b.rentalVehicleCost,
      render: (val) => `${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>Vehicle Information Details</h4>
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Can
                accessModule={accessCodes.others}
                accessCode={accessCodes.others_vehicle}
                accessType="haveAdd"
              >
                <Link
                  to={`${all_routes.vechile_master}/${all_routes.addvehicleinformation}`}
                  className="btn btn-added"
                >
                  <PlusCircle className="me-2" />
                  Add
                </Link>
              </Can>
            </div>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                  scroll={{ x: "max-content" }}
                  pagination={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleInformation;
